export const products = [
  {
    id: 1,
    img: "/woneassistant.png",
    link: "https://woneassistant.com",
  },
  {
    id: 2,
    img: "/woneschedule.png",
    link: "https://woneschedule.com",
  },
  {
    id: 3,
    img: "/artisaans.png",
    link: "https://artisaans.ng",
  },
  {
    id: 4,
    img: "/woneserve.png",
    link: "https://woneserve.com",
  },
  {
    id: 5,
    img: "/wonesuite.png",
    link: "http://wonesuite.com",
  },
  {
    id: 6,
    img: "/woneassistant.png",
    link: "http://woneassistant.com",
  },
];
